import { Client } from 'src/types/Client';

export enum PositionEnum {
  PromotorVT = 'Promotor VT',
  PromotorFree = 'Promotor Free/MEI',
  MEIPromotorComMoto = 'Promotor com moto',
  PromotorComCarro = 'Promotor com Carro',
  Degustador = 'Degustador(a)',
  Outros = 'Outros',
}

export enum StatusEnum {
  Open = 'Open',
  Sourcing = 'Sourcing',
  AwaitingApprovalClient = 'AwaitingApprovalClient',
  InDocumentation = 'InDocumentation',
  AwaitingDPApproval = 'AwaitingDPApproval',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export interface SaveVacancyDto {
  clientId: string;
  sector: string;
  regionId: string;
  position: PositionEnum;
  forms?: Record<string, any>;
}

export interface UpdateUserVacancyDto {
  userId: string | null;
}

export interface UpdateStatusVacancyDto {
  status: StatusEnum;
}

export interface UpdateVacancyCandidateDto {
  candidateId: string;
  candidateForms?: any;
}

export interface SearchVacancyDto {
  code?: number;
  clientId?: string;
  regionId?: string;
  userId?: string;
  status?: StatusEnum;
  startDateAt?: string;
  endDateAt?: string;
}

export interface Vacancy extends SaveVacancyDto {
  id: string;
  status: StatusEnum;
  code?: number;
  userId?: string | null;
  candidateId?: string | null;
  router?: string;
  createdAt?: string;
  candidateForms?: Record<string, any>;
  client: Client
}

export interface VacancyHistory {
  id: string;
  vacancyId: string;
  userId: string | null;
  actionText: string;
  createdAt: string;
}